export default __webpack_public_path__ + "static/steven-03c8cf48919a45d95dfe106cb990216d.webp";